"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DownloadController_1 = __importDefault(require("./DownloadController"));
var constantsDownload_1 = require("../../data/constantsDownload");
var constantsClasses_1 = require("../../data/constantsClasses");
/**
 * Download functionalities for download items and its buttons.
 *
 * @author Kevin Buchholz <kevin.buchholz@wendweb.de>
 */
var DownloadItem = /** @class */ (function () {
    function DownloadItem(element) {
        this.element = element;
        if (!this.element)
            return;
        this.downloadItems = this.element.querySelectorAll("[".concat(constantsDownload_1.DATA_DOWNLOAD_ITEM, "]"));
        this.errorMessage = this.element.querySelector("[".concat(constantsDownload_1.DATA_PRODUCT_DOWNLOADS_ERROR, "]")).innerHTML;
        this.initEventListeners();
    }
    Object.defineProperty(DownloadItem.prototype, "DownloadItems", {
        get: function () { return this.downloadItems; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DownloadItem.prototype, "ErrorMessage", {
        get: function () { return this.errorMessage; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DownloadItem.prototype, "getElement", {
        get: function () { return this.element; },
        enumerable: false,
        configurable: true
    });
    /**
     * Add listeners to buttons
     * @private
     */
    DownloadItem.prototype.initEventListeners = function () {
        var _this = this;
        this.downloadItems.forEach(function (element) {
            var downloadButton = element.querySelector("[".concat(constantsDownload_1.DATA_BUTTON_DOWNLOAD, "]"));
            var saveButton = element.querySelector("[".concat(constantsDownload_1.DATA_BUTTON_SAVE, "]"));
            var removeButton = element.querySelector("[".concat(constantsDownload_1.DATA_BUTTON_REMOVE, "]"));
            downloadButton.addEventListener('click', function () {
                _this.downloadSingleItem(element.dataset.downloadPath, downloadButton);
            });
            saveButton.addEventListener('click', function () {
                _this.addItem(element);
            });
            removeButton.addEventListener('click', function () {
                _this.removeItem(element.dataset.downloadPath);
            });
        });
    };
    /**
     * Activate/Deactivate visual components of action buttons
     * @param element
     * @param isActive
     */
    DownloadItem.prototype.updateButtonState = function (element, isActive) {
        var saveBtn = element.querySelector("[".concat(constantsDownload_1.DATA_BUTTON_SAVE, "]"));
        var removeBtn = element.querySelector("[".concat(constantsDownload_1.DATA_BUTTON_REMOVE, "]"));
        if (isActive) {
            saveBtn.classList.add(constantsClasses_1.CLASS_HIDDEN);
            removeBtn.classList.remove(constantsClasses_1.CLASS_HIDDEN);
        }
        else {
            saveBtn.classList.remove(constantsClasses_1.CLASS_HIDDEN);
            removeBtn.classList.add(constantsClasses_1.CLASS_HIDDEN);
        }
    };
    /**
     * Set all buttons to visually inactive
     */
    DownloadItem.prototype.setButtonsInactive = function () {
        var _this = this;
        this.downloadItems.forEach(function (element) {
            _this.updateButtonState(element, false);
        });
    };
    /**
     * Deactivate buttons while ajax call is running
     * @param element
     */
    DownloadItem.prototype.disableButtons = function (element) {
        var saveBtn = element.querySelector("[".concat(constantsDownload_1.DATA_BUTTON_SAVE, "]"));
        var removeBtn = element.querySelector("[".concat(constantsDownload_1.DATA_BUTTON_REMOVE, "]"));
        saveBtn.disabled = true;
        removeBtn.disabled = true;
    };
    /**
     * Activate buttons if ajax call returns success
     * @param element
     */
    DownloadItem.prototype.enableButtons = function (element) {
        var saveBtn = element.querySelector("[".concat(constantsDownload_1.DATA_BUTTON_SAVE, "]"));
        var removeBtn = element.querySelector("[".concat(constantsDownload_1.DATA_BUTTON_REMOVE, "]"));
        saveBtn.disabled = false;
        removeBtn.disabled = false;
    };
    /**
     * Download selected item.
     * @private
     */
    DownloadItem.prototype.downloadSingleItem = function (filePath, btn) {
        DownloadController_1.default.downloadSingleItem(this, filePath, btn);
    };
    /**
     * Add download item to cart
     * @private
     */
    DownloadItem.prototype.addItem = function (downloadElement) {
        DownloadController_1.default.addItem(this, downloadElement);
    };
    /**
     * Remove download item from cart
     * @private
     */
    DownloadItem.prototype.removeItem = function (filePath) {
        DownloadController_1.default.removeItem(filePath);
    };
    return DownloadItem;
}());
exports.default = DownloadItem;
